/* Elegance Coque — barre des pages de collection : « Filtrer » (tri, disponibilité, prix) + affichage grille / liste.
   Données réelles : prix, stock et dates viennent de /collections/<handle>/products.json ; « Meilleures ventes »
   vient du rendu Shopify de la section triée par best-selling. Les pages suivantes sont chargées pour que les filtres
   portent sur toute la collection. Le sélecteur d'iPhone de la page reste maître : on ne touche jamais au modèle. */
(function () {
  if (window.ECTB) { return; }
  var d = document, W = window;
  var MAIN = d.getElementById('MainContent');
  var PT = ((MAIN && MAIN.getAttribute('data-template')) || '').split('.')[0];
  var ROOT = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
  var CARD = '.lcard,.lcg-card,.lac-card';
  var VIEW_KEY = 'ec-view';
  var SORTS = [['best', 'Meilleures ventes'], ['new', 'Nouveautés'], ['price-asc', 'Prix croissant'], ['price-desc', 'Prix décroissant'], ['az', 'Nom de A à Z'], ['za', 'Nom de Z à A']];
  var FUNNEL = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 5h18l-7 8v5l-4 2v-7z"/></svg>';
  var GRID_I = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="4" y="4" width="7" height="7" rx="1.5"/><rect x="13" y="4" width="7" height="7" rx="1.5"/><rect x="4" y="13" width="7" height="7" rx="1.5"/><rect x="13" y="13" width="7" height="7" rx="1.5"/></svg>';
  var LIST_I = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="4" y="5" width="5" height="5" rx="1.2"/><rect x="4" y="14" width="5" height="5" rx="1.2"/><path d="M12 7.5h8M12 16.5h8"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19"/></svg>';

  /* l'ancienne barre de filtres (Modèle / Couleur / Caractéristiques) ne doit plus rien masquer */
  try { Object.keys(W.sessionStorage).forEach(function (k) { if (k.indexOf('ecpf:') === 0) { W.sessionStorage.removeItem(k); } }); } catch (e) {}

  function qa(r, s) { return [].slice.call((r || d).querySelectorAll(s)); }
  function esc(t) { var s = d.createElement('span'); s.textContent = t == null ? '' : String(t); return s.innerHTML; }
  function cents(v) { if (typeof v === 'number') { return v; } var n = parseFloat(String(v || '0').replace(',', '.')); return Math.round((isNaN(n) ? 0 : n) * 100); }
  function handleOf(u) { var m = String(u || '').match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function collHandle() { var m = location.pathname.match(/\/collections\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function getJSON(u) { return fetch(u, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { if (!r.ok) { throw new Error(r.status); } return r.json(); }); }
  function getText(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) { throw new Error(r.status); } return r.text(); }); }
  function readView() { try { return W.localStorage.getItem(VIEW_KEY) === 'list' ? 'list' : 'grid'; } catch (e) { return 'grid'; } }
  function saveView(v) { try { W.localStorage.setItem(VIEW_KEY, v); } catch (e) {} }
  function plural(n, w) { return n + ' ' + w + (n > 1 ? 's' : ''); }

  var JSONP = null;
  function catalog() {
    if (!JSONP) {
      var h = collHandle();
      JSONP = (function load(page, acc) {
        return getJSON(ROOT + 'collections/' + encodeURIComponent(h) + '/products.json?limit=250&page=' + page).then(function (j) {
          var ps = j.products || []; acc = acc.concat(ps);
          return ps.length === 250 && page < 8 ? load(page + 1, acc) : acc;
        });
      })(1, []).then(function (list) {
        var map = {};
        list.forEach(function (p) {
          var min = Infinity, av = false;
          (p.variants || []).forEach(function (v) { var c = cents(v.price); if (c > 0 && c < min) { min = c; } if (v.available) { av = true; } });
          map[p.handle] = { title: p.title || '', price: min === Infinity ? 0 : min, avail: av, t: Date.parse(p.published_at || p.created_at || '') || 0 };
        });
        return map;
      }).catch(function () { return {}; });
    }
    return JSONP;
  }

  /* ---------- une barre par grille de produits ---------- */
  function sectionOf(el) { return el.closest('.shopify-section'); }
  function sectionId(sec) { return sec && sec.id ? sec.id.replace(/^shopify-section-/, '') : ''; }
  function itemOf(card, grid) { var n = card; while (n && n.parentNode !== grid) { n = n.parentNode; } return n; }
  function gridsOnPage() {
    return qa(MAIN, 'ul').filter(function (u) {
      if (u.__ectb || u.closest('.ec-products,[data-lwl-page],.luxe-track,.lca,[data-ecp-pack],.ecp-rec')) { return false; }
      return [].some.call(u.children, function (li) { return li.matches && (li.matches(CARD) || li.querySelector(':scope > ' + CARD + ',:scope > article.lcg-card')); });
    });
  }

  function Bar(grid) {
    var self = this; grid.__ectb = this;
    this.grid = grid; this.sec = sectionOf(grid); this.sid = sectionId(this.sec);
    this.state = this.load(); this.draft = null; this.best = null; this.lock = false;
    this.data = {};
    this.build();
    this.setView(readView(), true);
    this.loadAllPages().then(function () { return catalog(); }).then(function (map) {
      self.data = map; self.bounds(); self.apply(); self.restoreScroll();
      if (self.state.sort === 'best') { self.fetchBest().then(function () { self.apply(); }); }
    });
    if (W.MutationObserver) {
      new MutationObserver(function () { if (self.lock) { return; } W.clearTimeout(self.t); self.t = W.setTimeout(function () { self.apply(); }, 60); })
        .observe(grid, { childList: true, attributes: true, attributeFilter: ['hidden'], subtree: true });
    }
  }
  Bar.prototype.key = function () { return 'ectb:' + location.pathname; };
  Bar.prototype.load = function () {
    var s = { sort: '', stock: {}, min: null, max: null };
    try { var v = JSON.parse(W.sessionStorage.getItem(this.key()) || 'null'); if (v) { s.sort = v.sort || ''; s.stock = v.stock || {}; s.min = v.min == null ? null : Number(v.min); s.max = v.max == null ? null : Number(v.max); } } catch (e) {}
    return s;
  };
  Bar.prototype.save = function () { try { W.sessionStorage.setItem(this.key(), JSON.stringify(this.state)); } catch (e) {} };

  Bar.prototype.build = function () {
    var self = this;
    var bar = d.createElement('div'); bar.className = 'ectb'; bar.setAttribute('data-ectb', '');
    bar.innerHTML = '<button type="button" class="ectb__filter" data-ectb-open aria-haspopup="dialog">' + FUNNEL + '<span>Filtrer</span><b class="ectb__badge" data-ectb-badge hidden></b></button>' +
      '<p class="ectb__count" data-ectb-count aria-live="polite"></p>' +
      '<div class="ectb__views" role="group" aria-label="Affichage des produits">' +
      '<button type="button" class="ectb__view" data-ectb-view="grid" aria-label="Affichage en grille" aria-pressed="true">' + GRID_I + '</button>' +
      '<button type="button" class="ectb__view" data-ectb-view="list" aria-label="Affichage en liste" aria-pressed="false">' + LIST_I + '</button></div>';
    /* remplace l'ancienne barre (compteur + « Recommandés ») à son emplacement */
    var old = this.sec && this.sec.querySelector('.ecat__bar,.emrq__bar,.esil__bar,.elux__bar,.lcat__bar,.lac__bar,.lcc__bar');
    if (old && old.parentNode) { old.parentNode.insertBefore(bar, old); } else { this.grid.parentNode.insertBefore(bar, this.grid); }
    this.bar = bar;
    var empty = d.createElement('div'); empty.className = 'ectb-empty'; empty.hidden = true;
    empty.innerHTML = '<p>Aucun produit ne correspond à ces filtres.</p><button type="button" class="ectb-empty__btn" data-ectb-reset-now>Réinitialiser les filtres</button>';
    this.grid.parentNode.insertBefore(empty, this.grid.nextSibling); this.empty = empty;
    bar.addEventListener('click', function (e) {
      var v = e.target.closest('[data-ectb-view]'); if (v) { self.setView(v.getAttribute('data-ectb-view')); return; }
      if (e.target.closest('[data-ectb-open]')) { self.open(); }
    });
    empty.addEventListener('click', function (e) { if (e.target.closest('[data-ectb-reset-now]')) { self.state = { sort: self.state.sort, stock: {}, min: null, max: null }; self.save(); self.apply(); } });
  };

  Bar.prototype.setView = function (v, quiet) {
    this.grid.classList.toggle('ectb-list', v === 'list');
    qa(this.bar, '[data-ectb-view]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ectb-view') === v ? 'true' : 'false'); });
    if (!quiet) { saveView(v); qa(d, '[data-ectb]').forEach(function (b) { if (b !== this.bar && b.__bar) { b.__bar.setView(v, true); } }, this); }
  };

  /* pages suivantes : on rapatrie leurs produits dans la grille et on retire la pagination */
  Bar.prototype.loadAllPages = function () {
    var self = this, sec = this.sec; if (!sec || !this.sid) { return Promise.resolve(); }
    var links = qa(sec, 'a[href*="page="]'), max = 1;
    links.forEach(function (a) { var m = a.getAttribute('href').match(/[?&]page=(\d+)/); if (m) { max = Math.max(max, Number(m[1])); } });
    var curM = location.search.match(/[?&]page=(\d+)/), cur = curM ? Number(curM[1]) : 1;
    if (max <= 1 && cur <= 1) { return Promise.resolve(); }
    var total = Math.max(max, cur), pages = [];
    for (var p = 1; p <= total; p++) { if (p !== cur) { pages.push(p); } }
    function url(p) { var u = new URL(location.href); u.searchParams.set('page', p); u.searchParams.set('section_id', self.sid); return u.toString(); }
    return Promise.all(pages.map(function (p) { return getText(url(p)).then(function (h) { return { p: p, h: h }; }).catch(function () { return null; }); })).then(function (res) {
      var gridSel = self.grid.className ? 'ul.' + self.grid.className.trim().split(/\s+/)[0] : 'ul';
      self.lock = true;
      res.filter(Boolean).sort(function (a, b) { return a.p - b.p; }).forEach(function (r) {
        var doc = new DOMParser().parseFromString(r.h, 'text/html'), g = doc.querySelector(gridSel);
        if (!g) { return; }
        [].slice.call(g.children).forEach(function (li) {
          if (!li.querySelector('a[href*="/products/"]')) { return; }
          var node = d.importNode(li, true);
          if (r.p < cur) { self.grid.insertBefore(node, self.grid.firstChild); } else { self.grid.appendChild(node); }
        });
      });
      qa(sec, 'nav').forEach(function (n) { if (n.querySelector('a[href*="page="]') || /pagination/i.test(n.getAttribute('aria-label') || '')) { n.hidden = true; n.classList.add('ectb-hide'); } });
      self.lock = false;
    });
  };

  Bar.prototype.items = function () {
    var g = this.grid;
    return [].slice.call(g.children).filter(function (li) { return li.querySelector && li.querySelector('a[href*="/products/"]'); }).map(function (li, i) {
      var a = li.querySelector('a[href*="/products/"]'), h = handleOf(a.getAttribute('href'));
      if (li.__ectbI == null) { li.__ectbI = i; }
      return { el: li, h: h, i: li.__ectbI };
    });
  };
  /* plage de prix fixe 0 – 1 000 DH (le filtre s'applique ensuite aux prix réels des produits) */
  var PMIN = 0, PMAX = 1000;
  Bar.prototype.bounds = function () { this.lo = PMIN; this.hi = PMAX; };
  /* visible = autorisé par le sélecteur d'iPhone de la page (attribut hidden posé par la section) */
  function modelOk(x) { var el = x.el; return !el.hidden && !(el.querySelector(CARD) || el).hidden && el.style.display !== 'none'; }
  Bar.prototype.passes = function (x, st) {
    var p = this.data[x.h]; if (!p) { return true; }
    var s = st.stock || {}, any = s['in'] || s.out;
    if (any && !((s['in'] && p.avail) || (s.out && !p.avail))) { return false; }
    var dh = p.price / 100;
    if (st.min != null && dh < st.min) { return false; }
    if (st.max != null && dh > st.max) { return false; }
    return true;
  };
  Bar.prototype.order = function (list, sort) {
    var self = this, D = this.data, best = this.best;
    function name(x) { return ((D[x.h] && D[x.h].title) || x.h).toLowerCase(); }
    return list.slice().sort(function (a, b) {
      var pa = D[a.h] || {}, pb = D[b.h] || {};
      switch (sort) {
        case 'best': return best ? ((best[a.h] == null ? 9999 : best[a.h]) - (best[b.h] == null ? 9999 : best[b.h]) || a.i - b.i) : a.i - b.i;
        case 'new': return (pb.t || 0) - (pa.t || 0) || a.i - b.i;
        case 'price-asc': return (pa.price || 0) - (pb.price || 0) || a.i - b.i;
        case 'price-desc': return (pb.price || 0) - (pa.price || 0) || a.i - b.i;
        case 'az': return name(a).localeCompare(name(b), 'fr') || a.i - b.i;
        case 'za': return name(b).localeCompare(name(a), 'fr') || a.i - b.i;
        default: return a.i - b.i;
      }
    });
  };
  Bar.prototype.fetchBest = function () {
    var self = this; if (this.best || !this.sid) { return Promise.resolve(); }
    var u = new URL(location.href); u.searchParams.set('sort_by', 'best-selling'); u.searchParams.set('section_id', this.sid); u.searchParams.delete('page');
    var hs = [];
    function grab(page) {
      if (page) { u.searchParams.set('page', page); }
      return getText(u.toString()).then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        qa(doc, CARD).forEach(function (c) { var a = c.querySelector('a[href*="/products/"]') || c.closest('li') && c.closest('li').querySelector('a[href*="/products/"]'); var x = a && handleOf(a.getAttribute('href')); if (x && hs.indexOf(x) < 0) { hs.push(x); } });
        var next = qa(doc, 'a[href*="page="]').map(function (a) { var m = a.getAttribute('href').match(/[?&]page=(\d+)/); return m ? Number(m[1]) : 0; }).filter(function (n) { return n > (page || 1); });
        return next.length && (page || 1) < 8 ? grab(Math.min.apply(null, next)) : null;
      });
    }
    return grab(0).then(function () { var m = {}; hs.forEach(function (h, i) { m[h] = i; }); self.best = m; }).catch(function () {});
  };
  Bar.prototype.apply = function () {
    if (this.lock) { return; }
    var self = this, st = this.state, all = this.items();
    var ordered = this.order(all, st.sort), n = 0, inModel = 0;
    this.lock = true;
    var cur = [].slice.call(this.grid.children).filter(function (li) { return all.some(function (x) { return x.el === li; }); });
    var same = ordered.length === cur.length && ordered.every(function (x, i) { return x.el === cur[i]; });
    if (!same) { ordered.forEach(function (x) { self.grid.appendChild(x.el); }); }
    ordered.forEach(function (x) {
      var ok = self.passes(x, st);
      x.el.classList.toggle('ectb-out', !ok);
      if (modelOk(x)) { inModel++; if (ok) { n++; } }
    });
    this.lock = false;
    var active = this.activeCount();
    var badge = this.bar.querySelector('[data-ectb-badge]'); badge.textContent = active; badge.hidden = !active;
    var cnt = this.bar.querySelector('[data-ectb-count]'), tx = plural(n, 'produit');
    if (cnt.textContent !== tx) { cnt.textContent = tx; }
    this.empty.hidden = !(inModel > 0 && n === 0);
  };
  Bar.prototype.activeCount = function () { var s = this.state, c = 0; if (s.stock['in']) { c++; } if (s.stock.out) { c++; } if (s.min != null || s.max != null) { c++; } if (s.sort) { c++; } return c; };

  /* ---------- panneau « Filtrer » ---------- */
  var dlg = null, curBar = null, lastFocus = null;
  function panel() {
    if (dlg) { return dlg; }
    dlg = d.createElement('dialog'); dlg.className = 'ectb-dlg'; dlg.setAttribute('aria-labelledby', 'ectb-t');
    dlg.innerHTML = '<div class="ectb-dlg__box"><header class="ectb-dlg__hd"><h2 id="ectb-t">Filtrer</h2><button type="button" class="ectb-dlg__x" data-ectb-close aria-label="Fermer">' + CLOSE + '</button></header>' +
      '<div class="ectb-dlg__body" data-ectb-body></div>' +
      '<footer class="ectb-dlg__ft"><button type="button" class="ectb-dlg__reset" data-ectb-reset>Réinitialiser</button><button type="button" class="ectb-dlg__apply" data-ectb-apply>Appliquer</button></footer></div>';
    d.body.appendChild(dlg);
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-ectb-close]')) { close(); return; }
      if (e.target.closest('[data-ectb-apply]')) { curBar.state = curBar.draft; curBar.save(); if (curBar.state.sort === 'best') { curBar.fetchBest().then(function () { curBar.apply(); }); } curBar.apply(); close(); return; }
      if (e.target.closest('[data-ectb-reset]')) { curBar.draft = { sort: '', stock: {}, min: null, max: null }; render(); return; }
    });
    dlg.addEventListener('change', onInput); dlg.addEventListener('input', onInput);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    return dlg;
  }
  function onInput(e) {
    var t = e.target, dr = curBar.draft;
    if (t.name === 'ectb-sort') { dr.sort = t.value; }
    else if (t.name === 'ectb-stock') { if (t.checked) { dr.stock[t.value] = 1; } else { delete dr.stock[t.value]; } }
    else if (t.hasAttribute('data-ectb-range')) {
      var lo = dlg.querySelector('[data-ectb-range="min"]'), hi = dlg.querySelector('[data-ectb-range="max"]');
      var a = Number(lo.value), b = Number(hi.value);
      if (a > b) { if (t === lo) { lo.value = b; a = b; } else { hi.value = a; b = a; } }
      dr.min = a <= curBar.lo ? null : a; dr.max = b >= curBar.hi ? null : b;
      dlg.querySelector('[data-ectb-num="min"]').value = a; dlg.querySelector('[data-ectb-num="max"]').value = b;
      paintRange();
    } else if (t.hasAttribute('data-ectb-num')) {
      var nmin = dlg.querySelector('[data-ectb-num="min"]'), nmax = dlg.querySelector('[data-ectb-num="max"]');
      if (e.type === 'input') {
        /* saisie en cours : le curseur suit dès que la valeur est valide, sans corriger le champ */
        var vi = t.value === '' ? NaN : Number(t.value), isMin = t === nmin;
        var other = Number((isMin ? nmax : nmin).value);
        if (isNaN(vi) || vi < curBar.lo || vi > curBar.hi || (isMin ? vi > other : vi < other)) { return; }
        dlg.querySelector('[data-ectb-range="' + (isMin ? 'min' : 'max') + '"]').value = vi;
        if (isMin) { dr.min = vi <= curBar.lo ? null : vi; } else { dr.max = vi >= curBar.hi ? null : vi; }
        paintRange(); countDraft(); return;
      }
      var x = Math.max(curBar.lo, Math.min(curBar.hi, Number(nmin.value) || curBar.lo)), y = Math.max(curBar.lo, Math.min(curBar.hi, Number(nmax.value) || curBar.hi));
      if (x > y) { var z = x; x = y; y = z; }
      nmin.value = x; nmax.value = y;
      dlg.querySelector('[data-ectb-range="min"]').value = x; dlg.querySelector('[data-ectb-range="max"]').value = y;
      dr.min = x <= curBar.lo ? null : x; dr.max = y >= curBar.hi ? null : y;
      paintRange();
    } else { return; }
    countDraft();
  }
  function paintRange() {
    var lo = dlg.querySelector('[data-ectb-range="min"]'), hi = dlg.querySelector('[data-ectb-range="max"]'), tr = dlg.querySelector('.ectb-range__fill');
    if (!lo || !tr) { return; }
    var span = (curBar.hi - curBar.lo) || 1;
    tr.style.left = ((Number(lo.value) - curBar.lo) / span * 100) + '%';
    tr.style.right = (100 - (Number(hi.value) - curBar.lo) / span * 100) + '%';
    /* poignées superposées en haut de la plage : la poignée « min » passe dessus pour rester saisissable */
    lo.style.zIndex = Number(lo.value) >= curBar.hi - (curBar.hi - curBar.lo) * 0.02 ? '3' : '1'; hi.style.zIndex = '2';
  }
  function countDraft() {
    var b = curBar, n = 0;
    b.items().forEach(function (x) { if (modelOk(x) && b.passes(x, b.draft)) { n++; } });
    var btn = dlg.querySelector('[data-ectb-apply]'); btn.textContent = 'Appliquer (' + plural(n, 'produit') + ')';
  }
  function render() {
    var b = curBar, dr = b.draft, inS = 0, outS = 0, html = '';
    b.items().forEach(function (x) { if (!modelOk(x)) { return; } var p = b.data[x.h]; if (!p) { return; } if (p.avail) { inS++; } else { outS++; } });
    html += '<fieldset class="ectb-grp"><legend>Trier par</legend><div class="ectb-opts">';
    SORTS.forEach(function (s) { html += '<label class="ectb-opt"><input type="radio" name="ectb-sort" value="' + s[0] + '"' + (dr.sort === s[0] ? ' checked' : '') + '><span>' + s[1] + '</span></label>'; });
    html += '</div></fieldset>';
    html += '<fieldset class="ectb-grp"><legend>Disponibilité</legend><div class="ectb-opts">' +
      '<label class="ectb-opt ectb-opt--check"><input type="checkbox" name="ectb-stock" value="in"' + (dr.stock['in'] ? ' checked' : '') + (inS ? '' : ' disabled') + '><span>En stock</span><em>' + inS + '</em></label>' +
      '<label class="ectb-opt ectb-opt--check"><input type="checkbox" name="ectb-stock" value="out"' + (dr.stock.out ? ' checked' : '') + (outS ? '' : ' disabled') + '><span>En rupture de stock</span><em>' + outS + '</em></label></div></fieldset>';
    var a = dr.min != null ? dr.min : b.lo, z = dr.max != null ? dr.max : b.hi;
    html += '<fieldset class="ectb-grp"><legend>Prix</legend>' +
      '<div class="ectb-range"><span class="ectb-range__track"><span class="ectb-range__fill"></span></span>' +
      '<input type="range" data-ectb-range="min" min="' + b.lo + '" max="' + b.hi + '" step="1" value="' + a + '" aria-label="Prix minimum">' +
      '<input type="range" data-ectb-range="max" min="' + b.lo + '" max="' + b.hi + '" step="1" value="' + z + '" aria-label="Prix maximum"></div>' +
      '<div class="ectb-nums"><label>Min<span><input type="number" inputmode="numeric" data-ectb-num="min" min="' + b.lo + '" max="' + b.hi + '" step="1" value="' + a + '"><i>DH</i></span></label>' +
      '<label>Max<span><input type="number" inputmode="numeric" data-ectb-num="max" min="' + b.lo + '" max="' + b.hi + '" step="1" value="' + z + '"><i>DH</i></span></label></div></fieldset>';
    dlg.querySelector('[data-ectb-body]').innerHTML = html;
    paintRange(); countDraft();
  }
  function close() {
    if (!dlg) { return; }
    if (dlg.close) { dlg.close(); } else { dlg.removeAttribute('open'); }
    d.documentElement.classList.remove('ectb-lock');
    if (lastFocus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  Bar.prototype.open = function () {
    var g = panel(); curBar = this; lastFocus = this.bar.querySelector('[data-ectb-open]');
    this.draft = JSON.parse(JSON.stringify(this.state));
    var self = this;
    render();
    if (g.showModal) { g.showModal(); } else { g.setAttribute('open', ''); }
    d.documentElement.classList.add('ectb-lock');
    var x = g.querySelector('[data-ectb-close]'); if (x) { x.focus({ preventScroll: true }); }
    if (!Object.keys(this.data).length) { catalog().then(function (m) { self.data = m; self.bounds(); render(); }); }
  };

  /* retour depuis une fiche : même position dans la liste */
  Bar.prototype.restoreScroll = function () {
    try {
      var y = Number(W.sessionStorage.getItem('ecpy:' + location.pathname) || 0);
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (y > 0 && nav && nav.type === 'back_forward') { W.scrollTo(0, y); }
    } catch (e) {}
  };
  W.addEventListener('pagehide', function () { if (PT === 'collection') { try { W.sessionStorage.setItem('ecpy:' + location.pathname, String(W.scrollY || 0)); } catch (e) {} } });

  function boot() {
    if (PT !== 'collection' || !MAIN) { return; }
    gridsOnPage().forEach(function (g) { var b = new Bar(g); b.bar.__bar = b; });
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  d.addEventListener('shopify:section:load', function () { W.setTimeout(boot, 80); });
  W.ECTB = { boot: boot };
})();
